/* Coffee Cruise — prenumeratos kainos pakopos ir dovanos krepšelyje.
   Nuolaida priklauso nuo bendro prenumeratos eilučių svorio (pupelės 1 kg,
   malta 250 g): iki 2 kg −25 %, nuo 2 kg −30 %, nuo 3 kg −35 %, nuo 4 kg −40 %.
   Shopify planai — po vieną kiekvienai pakopai ir dažniui. Šis skriptas
   kiekviename puslapyje (ir pakeitus krepšelį) patikrina, ar kiekvienai
   eilutei priskirtas tinkamos pakopos planas tuo pačiu dažniu, ir pataiso.
   Kainos visada lieka Shopify plano kainos — čia tik parenkamas planas.
   Turi sutapti su TIERS assets/pren.js ir sections/pren-product.liquid.

   DOVANOS: temos nustatymai → "Coffee Cruise dovanos" (produktas + nuo kiek
   kg). Konfigūracija — <script data-pren-gifts> (layout/theme.liquid).
   Pasiekus kiekį dovana įdedama (1 vnt., 0 €, savybė _pren_gift), nukritus —
   išimama. Jei dovanos produktas įtrauktas į prenumeratos planus, ji dedama
   tuo pačiu dažniu ir atkeliauja kiekvienoje siuntoje; jei ne — tik pirmoje.
   Dovanos į svorį neįskaičiuojamos. */
(function () {
  "use strict";
  var TIERS = [{ kg: 4, pct: 40 }, { kg: 3, pct: 35 }, { kg: 2, pct: 30 }, { kg: 0, pct: 25 }];
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var busy = false, again = false;

  var GIFTS = [];
  try {
    var gEl = document.querySelector("script[data-pren-gifts]");
    if (gEl) GIFTS = JSON.parse(gEl.textContent || "[]") || [];
  } catch (e) { GIFTS = []; }
  var GIFT_VIDS = {};
  GIFTS.forEach(function (g) { GIFT_VIDS[g.vid] = g; });

  function tierPct(kg) {
    for (var i = 0; i < TIERS.length; i++) if (kg + 1e-9 >= TIERS[i].kg) return TIERS[i].pct;
    return TIERS[TIERS.length - 1].pct;
  }
  /* dažnis iš plano pavadinimo: "Kas 2 mėnesius, −25%" / "Deliver every 2 months, 25% off" */
  function monthsOf(name) {
    var t = String(name || "").toLowerCase().replace(/\d+\s*%/g, " ");
    var m = t.match(/(\d+)\s*(m[eė]n|month)/);
    if (m) return parseInt(m[1], 10) || 1;
    if (/m[eė]n|month/.test(t)) return 1;
    var w = t.match(/(\d+)\s*(savait|week)/);
    if (w) return (parseInt(w[1], 10) || 1) / 4.345;
    return null;
  }
  function pctOf(plan) {
    var a = plan.price_adjustments || [];
    for (var i = 0; i < a.length; i++) if (a[i].value_type === "percentage") return a[i].value;
    return null;
  }
  function getJSON(u) {
    return fetch(u, { headers: { "Accept": "application/json" }, credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function post(path, body) {
    return fetch(ROOT + path, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(path + " " + r.status); return true; });
  }
  var prodCache = {};
  function product(handle) {
    if (!prodCache[handle]) prodCache[handle] = getJSON(ROOT + "products/" + encodeURIComponent(handle) + ".js");
    return prodCache[handle];
  }

  function plansOf(p) {
    var out = [];
    (p.selling_plan_groups || []).forEach(function (g) {
      (g.selling_plans || []).forEach(function (s) {
        out.push({ id: s.id, pct: pctOf(s), months: monthsOf(s.name) });
      });
    });
    return out;
  }
  function gramsOf(p, variantId, title) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].id === variantId && vs[i].weight > 0) return vs[i].weight;
    }
    return /250\s*g/i.test(title || p.title || "") ? 250 : 1000;
  }
  function isGift(it) {
    return !!(GIFT_VIDS[it.variant_id] || (it.properties && it.properties._pren_gift) || /^dovana-/.test(it.handle || ""));
  }

  /* Vienas žingsnis; grąžina true, jei kažką pakeitė (tada kviečiamas dar kartą,
     nes po pakeitimo eilučių raktai pasikeičia). */
  function checkOnce() {
    return getJSON(ROOT + "cart.js").then(function (cart) {
      var items = cart.items || [];
      var subs = items.filter(function (it) { return it.selling_plan_allocation && !isGift(it); });
      var gifts = items.filter(isGift);
      if (!subs.length && !gifts.length) return false;
      return Promise.all(subs.map(function (it) { return product(it.handle); })).then(function (prods) {
        var grams = 0, rows = [];
        subs.forEach(function (it, i) {
          var p = prods[i];
          grams += gramsOf(p, it.variant_id, it.product_title) * it.quantity;
          rows.push({ it: it, plans: plansOf(p) });
        });
        var kg = grams / 1000, want = tierPct(kg), months = null;

        /* 1) pakopos */
        for (var k = 0; k < rows.length; k++) {
          var it = rows[k].it, plans = rows[k].plans;
          var curId = it.selling_plan_allocation.selling_plan.id, cur = null;
          for (var c = 0; c < plans.length; c++) if (plans[c].id === curId) cur = plans[c];
          if (!cur || cur.months === null) continue;
          if (months === null) months = cur.months;
          var target = null, lower = null;
          plans.forEach(function (s) {
            if (s.months !== cur.months || s.pct === null) return;
            if (s.pct === want) target = s;
            else if (s.pct < want && (!lower || s.pct > lower.pct)) lower = s;
          });
          target = target || lower;
          if (target && target.id !== curId) {
            return post("cart/change.js", { id: it.key, quantity: it.quantity, selling_plan: target.id });
          }
        }

        /* 2) dovanos */
        /* pirkėjas gali dovanos atsisakyti krepšelyje: _pren_gift_off = "vid,vid" */
        var off = {};
        String((cart.attributes && cart.attributes._pren_gift_off) || "").split(",").forEach(function (v) { if (v) off[v] = true; });
        var wantG = {};
        if (subs.length) GIFTS.forEach(function (g) { if (kg + 1e-9 >= g.kg && !off[String(g.vid)]) wantG[g.vid] = g; });
        /* nereikalingos arba ne po 1 */
        var seenG = {};
        for (var x = 0; x < gifts.length; x++) {
          var gi = gifts[x];
          if (!wantG[gi.variant_id] || seenG[gi.variant_id]) {
            return post("cart/change.js", { id: gi.key, quantity: 0 });
          }
          seenG[gi.variant_id] = true;
          if (gi.quantity !== 1) return post("cart/change.js", { id: gi.key, quantity: 1 });
        }
        /* dovanos planas — tos pačios pakopos kaip kava (kaina vis tiek 0 €, bet
           krepšelyje ir laiškuose nerodomas kitas procentas) */
        var giftSubs = gifts.filter(function (gi) { return gi.selling_plan_allocation && wantG[gi.variant_id]; });
        if (giftSubs.length) {
          return Promise.all(giftSubs.map(function (gi) { return product(gi.handle); })).then(function (gps) {
            for (var q = 0; q < giftSubs.length; q++) {
              var gl = giftSubs[q], gpl = plansOf(gps[q]);
              var gcur = gl.selling_plan_allocation.selling_plan.id, gcm = null;
              gpl.forEach(function (s) { if (s.id === gcur) gcm = s; });
              if (!gcm) continue;
              var gt = null;
              gpl.forEach(function (s) { if (s.months === gcm.months && s.pct === want) gt = s; });
              if (gt && gt.id !== gcur) return post("cart/change.js", { id: gl.key, quantity: 1, selling_plan: gt.id });
            }
            return addMissing();
          });
        }
        return addMissing();

        function addMissing() {
        /* trūkstamos */
        var missing = Object.keys(wantG).filter(function (vid) { return !seenG[vid]; });
        if (!missing.length) return false;
        var g0 = wantG[missing[0]];
        return product(g0.handle).then(function (gp) {
          var line = { id: g0.vid, quantity: 1, properties: { _pren_gift: "1" } };
          /* dovana kiekvienoje siuntoje — jei produktas turi to paties dažnio planą */
          if (months !== null) {
            var gpl = plansOf(gp).filter(function (s) { return s.months === months; });
            var same = gpl.filter(function (s) { return s.pct === want; });
            if (same.length) line.selling_plan = same[0].id;
            else if (gpl.length) line.selling_plan = gpl[0].id;
          }
          return post("cart/add.js", { items: [line] });
        });
        }
      });
    });
  }

  function run() {
    if (busy) { again = true; return; }
    busy = true;
    var changed = false, n = 0;
    (function step() {
      checkOnce().then(function (did) {
        if (did && ++n < 16) { changed = true; return step(); }
        busy = false;
        if (changed && /\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        if (again) { again = false; run(); }
      }).catch(function (e) {
        busy = false;
        if (window.console) console.warn("[pren-tiers]", e);
      });
    })();
  }
  window.prenTiersCheck = run;
  /* Pažadas: sutvarko pakopas ir dovanas, išsisprendžia kai krepšelis galutinis
     (naudoja konfigūratorius prieš vedant tiesiai į atsiskaitymą). */
  window.prenTiersSync = function () {
    var n = 0;
    function step() { return checkOnce().then(function (did) { return did && ++n < 16 ? step() : true; }); }
    return step();
  };

  run();
  /* PUB_SUB_EVENTS — Dawn "const", ne window savybė */
  try {
    /* global subscribe, PUB_SUB_EVENTS */
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(run, 50); });
    }
  } catch (e) { /* ne Dawn tema */ }
  document.addEventListener("cart:updated", function () { setTimeout(run, 50); });
  /* grįžus į skirtuką ar puslapį iš talpyklos */
  window.addEventListener("pageshow", function (e) { if (e.persisted) run(); });
})();
